import { createReducer } from "redux-create-reducer";

import {
  EXPORT_SCORING_RESULTS_REPORT_CSV,
  CLEAR_EXPORT_SCORING_RESULTS_REPORT_CSV,
} from "../../types";

const initialState = {
  data: {},
  isLoading: false,
};

const exportSingleClientReportCsvReducer = createReducer(initialState, {
  [EXPORT_SCORING_RESULTS_REPORT_CSV.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_SCORING_RESULTS_REPORT_CSV.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_SCORING_RESULTS_REPORT_CSV.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [EXPORT_SCORING_RESULTS_REPORT_CSV.FULFILLED]: (state, { payload }) => {
    // const fileName = payload.headers['content-disposition'].split('filename=')[1].split(';')[0];
    const newState = Object.assign({}, state, {
      data: {
        fileBytes: new Blob([payload.data], { type: "text/csv" }),
        fileName: payload.headers["content-disposition"]
          .split("filename=")[1]
          .split(";")[0]
          .replace(".csv", ""), // type option will take care of the extension
      },
      isLoading: false,
    });
    return newState;
  },
  [CLEAR_EXPORT_SCORING_RESULTS_REPORT_CSV]: () => {
    return initialState;
  },
});

export default exportSingleClientReportCsvReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/scoring-results/exportScoringResultsReportCsvReducer.js